/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: wGRnXZTfU7ft
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicSeparatorVertical.module.css"; // plasmic-import: wGRnXZTfU7ft/css

createPlasmicElementProxy;

export const PlasmicSeparatorVertical__VariantProps = new Array();

export const PlasmicSeparatorVertical__ArgProps = new Array();

const $$ = {};

function PlasmicSeparatorVertical__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"typeUiSeparatorLineTypeContinuousSize2Px"}
      data-plasmic-override={overrides.typeUiSeparatorLineTypeContinuousSize2Px}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.typeUiSeparatorLineTypeContinuousSize2Px
      )}
    />
  );
}

const PlasmicDescendants = {
  typeUiSeparatorLineTypeContinuousSize2Px: [
    "typeUiSeparatorLineTypeContinuousSize2Px"
  ]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSeparatorVertical__ArgProps,
          internalVariantPropNames: PlasmicSeparatorVertical__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSeparatorVertical__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "typeUiSeparatorLineTypeContinuousSize2Px") {
    func.displayName = "PlasmicSeparatorVertical";
  } else {
    func.displayName = `PlasmicSeparatorVertical.${nodeName}`;
  }
  return func;
}

export const PlasmicSeparatorVertical = Object.assign(
  // Top-level PlasmicSeparatorVertical renders the root element
  makeNodeComponent("typeUiSeparatorLineTypeContinuousSize2Px"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicSeparatorVertical
    internalVariantProps: PlasmicSeparatorVertical__VariantProps,
    internalArgProps: PlasmicSeparatorVertical__ArgProps
  }
);

export default PlasmicSeparatorVertical;
/* prettier-ignore-end */
